(function(){
    'use strict';

    var topMenu = $('#top_nav'),
        navBtn = $('.topNavBtn');

    if (device.desktop() && window.location.pathname != '/') {
        topMenu.addClass('header_nav--active');
    }

    navBtn.on('click', function(){
        topMenu.toggleClass('header_nav--active');
    });

})();